import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Tema } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteTema, useTema, useUpdateTema } from '../../hooks/temi'
import TemaForm from '../../components/TemaForm'

export default function TemaEdit() {
  const { id } = useParams()
  const { data: tema } = useTema(+id!)
  const deleteTema = useDeleteTema()
  const updateTema = useUpdateTema()
  const [modalRm, modalRmActions] = useModalTrigger<Tema>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/temi">Temi</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {tema!.nome}
            </li>
          </ol>
        </nav>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-danger"
            onClick={() => modalRmActions.open(tema)}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </div>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <TemaForm
          tema={tema}
          save={(tema) =>
            updateTema.mutateAsync(tema).then(() =>
              toast.success('Tema salvato con successo!', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il tema {modalRm.value.nome} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteTema.isLoading}
            onClick={async () => {
              await deleteTema.mutateAsync(modalRm.value!.id)
              navigate('/temi')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
